/**
 * Базовые утилиты для маппинга
 */

/**
 * Преобразует строку даты в Date объект
 */
export function mapDate(dateString?: string | null): Date | undefined {
  if (!dateString) return undefined
  return new Date(dateString)
}

/**
 * Преобразует Date объект в строку ISO
 */
export function mapDateToString(date?: Date | null): string | undefined {
  if (!date) return undefined
  return date.toISOString()
}

/**
 * Преобразует значение в число или undefined
 */
export function mapNumber(value?: string | number | null): number | undefined {
  if (value === null || value === undefined) return undefined
  const num = typeof value === 'string' ? parseFloat(value) : value
  return isNaN(num) ? undefined : num
}

/**
 * Преобразует значение в строку или undefined
 */
export function mapString(value?: string | number | null): string | undefined {
  if (value === null || value === undefined) return undefined
  return String(value)
}

/**
 * Преобразует значение в boolean или undefined
 */
export function mapBoolean(value?: boolean | string | number | null): boolean | undefined {
  if (value === null || value === undefined) return undefined
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || value === '1'
  }
  if (typeof value === 'number') {
    return value !== 0
  }
  return undefined
}

